export { default as NewsletterForm } from "./Form/Newsletter";
export { default as EbrochureForm } from "./Form/Ebrochure";
export { default as ComingSoon } from "./ComingSoon";
export { default as GalleryImages } from "./GalleryImages";
export { default as TypeResidences } from "./TypeResidences";
export { default as TypeResidenceVirtual } from "./TypeResidenceVirtual";
export { default as EbrochureDownload } from "./EbrochureDownload";


// WEBPACK FOOTER //
// ./src/containers/index.js